import { useContext } from "react";
import { useParams } from "react-router";
import { Context } from "../context/DataContext";
import useCustomerBlock from "@shared/hooks/useCustomerBlock";
import RenderDisabledCustomer from "@shared/components/RenderDisabledCustomer";
import RenderDebtorForm from "@shared/components/RenderDebtorForm";
import { FaUserEdit } from "react-icons/fa";
import Loading from "@shared/components/Loading";
import { UseDebtors } from "@shared/server/fetcher";
import RenderBackButton from "@shared/components/RenderBackButton";

const DebtorEdit = ({ history }) => {
  const { id: dUniqueId } = useParams();
  const { state, updateDebtor } = useContext(Context);
  const { user, route } = state;

  const { data: debtors, isLoading: debtorLoading, mutate } = UseDebtors(route.creditor_id, user.user_id);
  const block = useCustomerBlock(route?.user_id);
  const debtor = debtors?.find((x) => x.dUniqueId === dUniqueId);

  if (debtorLoading || block.isChecking) return <Loading />;
  if (block.isBlocked) return <RenderDisabledCustomer {...block.disabledProps} />;

  const initialValues = {
    debtor_id: debtor.debtor_id,
    name: debtor.name ? debtor.name : "",
    cedula: debtor.cedula ? debtor.cedula : "",
    phone: debtor.phone ? debtor.phone : "",
    phone2: debtor.phone2 ? debtor.phone2 : "",
    nickname: debtor.nickname ? debtor.nickname : "",
    display_name: debtor.display_name ? debtor.display_name : "",
    birthdate: "",
    address: debtor.address ? debtor.address : "",
    work_address: debtor.work_address ? debtor.work_address : "",
    next_to: debtor.next_to ? debtor.next_to : "",
    cosigner: debtor.cosigner ? debtor.cosigner : "",
    note: debtor.note ? debtor.note : "",
    occupation: debtor.occupation ? debtor.occupation : "",
    auto_sms: 0,
    zone_id: debtor.zone_id ? debtor.zone_id : 0,
  };

  const button = {
    icon: <FaUserEdit size="0.9em" />,
    label: "Actualizar Cliente",
    variant: "contained",
    color: "primary",
  };

  const submithandler = async (data) => {
    await updateDebtor(data);
    await mutate();
    // mutate2(`/debtors/${route.creditor_id}/${user.user_id}`);
    history.push(`/debtor/profile/${dUniqueId}`);
  };

  return (
    <div className="container mt-3 mb-5">
      <RenderDebtorForm
        title="Actualizar Cliente!"
        initialValues={initialValues}
        submithandler={submithandler}
        button={button}
      />
      <div className="mt-4">
        <RenderBackButton />
      </div>
    </div>
  );
};

export default DebtorEdit;
